// Generate a random 5-character room code e.g. "AB12C"
export const generateRoomCode = () => {
  return Math.random().toString(36).substring(2, 7).toUpperCase();
};

// Get result from MY perspective
// Returns "win" | "lose" | "draw" | null
export const getMyResult = (myChoice, oppChoice) => {
  if (!myChoice || !oppChoice) return null;
  if (myChoice === oppChoice) return "draw";
  const wins = { rock: "scissors", paper: "rock", scissors: "paper" };
  return wins[myChoice] === oppChoice ? "win" : "lose";
};